<template>
  <div class="site-footer">
    <div class="nav-footer">
      <ul class="menu">
        <li class="menu-item"><a :href="$utils.getWpPath('')">หน้าแรก</a></li>
        <li class="menu-item"><a :href="$utils.getWpPath('about')" >เกี่ยวกับ กสศ.</a></li>
        <li class="menu-item"><a :href="$utils.getWpPath('fund')" >ทุนสร้างโอกาส</a></li>
        <li class="menu-item"><a :href="$utils.getWpPath('our-work')" >นวัตกรรมต้นแบบ</a></li>
        <li class="menu-item"><a :href="$utils.getWpPath('success-case')" >บอกเล่าความสำเร็จ</a></li>
        <li class="menu-item"><a :href="$utils.getWpPath('knowledge')" >คลังสมอง</a></li>
        <li class="menu-item"><a :href="$utils.getWpPath('contact')" >ติดต่อเรา</a></li>
      </ul>
    </div>
    <div class="bottom-footer">
      <div class="container">
      <div class="text-center">
        <img class="logo-footer"
          src="../assets/domain-custom/base/logo-domain.png"
          :srcset="`${require('../assets/domain-custom/base/logo-domain.png')} 1x, ${require('../assets/domain-custom/base/logo-domain@2x.png')} 2x`" alt="LOGO TCFE" />
        <div class="">
          กองทุนเพื่อความเสมอภาคทางการศึกษา (กสศ.)<br />
          อาคารเอส. พี. (อาคารเอ) ชั้น 13 เลขที่ 388<br />
          ถนนพหลโยธิน แขวงสามเสนใน เขตพญาไท กรุงเทพมหานคร 10400<br />
          โทรศัพท์ : 02-079-5475, โทรสาร: 02-619-1812<br />
          www.eef.or.th
        </div>
        <div class="social-media">
          <a href="https://www.facebook.com/EEFthailand/" target="_blank" class="ic_facebook">Facebook</a> <a href="https://www.youtube.com/user/QLFthailand/" target="_blank" class="ic_youtube">Youtube</a>
        </div>
      </div>
    </div>
    </div> <!-- /bottom Footer -->


  </div>
</template>

<script>
  export default {
    name: 'SiteFooter'
  }
</script>

<style scoped lang="scss">

.site-footer {
  background: #fff;
}

.nav-footer {
  padding: 1rem;
  background: #134169;
  font-size: 17px;
  line-height: 1.5em;
  > .menu {
    list-style: none;
    padding: 0;
    margin: 0;
    text-align: center;
    overflow: hidden;
    > .menu-item {
      margin: 0 15px 10px;
      display: inline-block;
      padding: 0;
      font-size: 0.95rem;
      @media (min-width: 768px) {
        display: inline-block;
        font-size: 1.1rem
      }
      a {
        color: #fff;
        transition: all 0.3s ease 0s;
        &:hover, &.router-link-active {
          text-decoration: none;
          color: #a0d4e3
        }
      }
    }
  }
}

.bottom-footer {
  background: #134169;
}

.bottom-footer .container{
  padding: 20px 0;
  font-size: 0.85em;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  line-height: 1.5em;
  display: flex;
  justify-content: space-between;
  color: #fff;
  > .col {
    flex-grow: 1;
  }
}
.logo-footer {
  margin-bottom: 20px;
  max-width: 60px;
}
.social-list {
  float: right;
  list-style: none;
  padding: 0;
  margin: 0;
  > .social-item {
    display: inline-block;
    a {
      font-size: 25px;
      padding: 8px 10px;
      border-radius: 2px;
      background: #f7dfcf;
      color: #f8941d;
      line-height: 1.2em;
      text-align: center;
      display: inline-block;
      transition: all 0.3s ease 0s;
      &:hover {
        background: #f8941d;
        color: #ffffff;
        text-decoration: none;
      }
    }
  }
}
/* Footer Social Media*/
.social-footer {
  max-width: 400px;
  float: right;
}
.social-footer a {
	color: #525252;
}
@media (max-width: 768px) {
  .social-footer {
    float: none;
    margin: 0 auto;
  }
}

.social-media {
  margin-top: 1rem;
  a {
      display: inline-block;
      width: 35px;
      height: 35px;
      text-indent: -999em;
      margin-left: 0.5rem;
      background-image: url("../assets/img/ic-facebook@2x.png");
      background-size: 45px;
      transition: all 0.5s;
      opacity: 1;
      &:hover {
          opacity: 0.75;
      }
  }
  .ic_facebook {
      background-image: url("../assets/img/ic-facebook@2x.png");
      background-size: 35px;
  }
  .ic_youtube {
      background-image: url("../assets/img/ic-youtube@2x.png");
      background-size: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// SiteFooter.vue?10cdc947